<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_pest_control" name="is_pest_control" rules="" v-slot="{ errors }">
              <small class="label">10.1 Is the manufacturing site covered by a pest control contract?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" :default="false" v-model="form.is_pest_control" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0" v-if="form.is_pest_control">
            <ValidationProvider vid="is_pest_control_yes" name="is_pest_control_yes" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please state the company used, and the number/type of visits per year.</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_pest_control_yes" class="w-full" v-model="form.is_pest_control_yes" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0" v-if="!form.is_pest_control">
            <ValidationProvider vid="is_pest_control_no" name="is_pest_control_no" rules="required" v-slot="{ errors }">
              <small class="label">If no, please state current practice</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_pest_control_no" class="w-full" v-model="form.is_pest_control_no" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="pest_control_contract" name="pest_control_contract" rules="required" v-slot="{ errors }">
              <small class="label">10.2 What is covered by pest control contract?</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="pest_control_contract" class="w-full" v-model="form.pest_control_contract" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_pest_complete === 1"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_pest_control: false
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_pest_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.UpdateManufacturePestDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture PEST Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.CreateManufacturePestDetails(this.form))
          this.showSuccessMessage('Manufacture PEST Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufacturePestDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_pest_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
